import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import Header from '../../../components/header/Header';
import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import ButtonNetwork from '../../../utils/network-connect/ButtonNetwork';
import { showNotificationDialog } from '../../../utils';
import isOnline from '../../../utils/network-connect/NetworkConnect';
import { EMAIL_REGEX_PATTERN } from '../../../utils/Constants';

/**
 * 図103-1 パスワード再設定メールアドレス入力画面
 * パスワードを忘れた方はこちらからの画面
 */
const ResetPasswordEmailInputScreen = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { forgotPassword } = useFujiAuth();

    const onFinish = ({ email }: { email: string }) => {
        if (isOnline()) {
            setIsLoading(true);
            // 小文字に変換する
            const emailLower = email.trim().toLowerCase();
            forgotPassword(
                emailLower,
                ({ isSuccessed, error }: { isSuccessed: boolean; error: { code: string; message: string[] } }) => {
                    setIsLoading(false);
                    if (isSuccessed || error.code === 'UserNotFoundException') {
                        //パスワード再設定ページに遷移
                        navigate('/auth/new-password', { state: { email: emailLower } });
                    } else if (error.code === 'LimitExceededException') {
                        // MSG.12-E2 確認コードのメールの送信上限に達している。
                        showNotificationDialog(
                            'error',
                            'password-reset',
                            t('notification.title'),
                            t('error-message.forgot-password.send-code-limit'),
                        );
                    } else {
                        // MSG.12-E3 確認コードのメールの送信に失敗（その他のエラー）
                        showNotificationDialog(
                            'error',
                            'password-reset',
                            t('notification.title'),
                            t('error-message.forgot-password.send-code-failed') + ' ' + error.code,
                        );
                    }
                },
            );
        } else {
            showNotificationDialog('error', '', t('notification.title'), t('error-message.server-error'));
        }
    };

    const onFinishFailed = () => {};
    return (
        <React.Fragment>
            {isLoading && <CenterLoading overFooter={true} />}
            <Header title={t('header.forgot-password')} />
            <div className={`content-footer-container scrollable ${styles.forgotContainer}`}>
                <div className={styles.content}>
                    <div className={styles.title}>
                        <p>{t('forgot-password.title')}</p>
                        <p>{t('forgot-password.enter-mail')}</p>
                    </div>
                    <Form
                        className={styles.forgotForm}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                    >
                        <Form.Item
                            name="email"
                            initialValue={''}
                            rules={[
                                {
                                    pattern: EMAIL_REGEX_PATTERN,
                                    message: t('validate.correct-email') ?? '',
                                },
                                {
                                    required: true,
                                    message: t('validate.email') ?? '',
                                },
                            ]}
                        >
                            <Input
                                style={{ borderRadius: 4, height: 50 }}
                                placeholder={t('form.email') ?? ''}
                                size="large"
                                autoComplete=""
                                allowClear
                            />
                        </Form.Item>
                        <Form.Item>
                            <ButtonNetwork title={t('button.send')} type="submit" />
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ResetPasswordEmailInputScreen;
